module.exports = __webpack_public_path__ + "img/tema-3-1.c1e1ab16.svg";